import { StyledTableRow } from './Row.styles';
import { ICell, IRowProps } from '../../table.interfaces';
import { allCells } from '../../Cells/cells.consts';
import { SyntheticEvent } from 'react';
import { CellType } from '../../table.consts';

const Row = (props: IRowProps) => {
    const { rowData, structure, callbacks, onSelectionChange, isSelected } =
        props;
    const { index: rowIndex, data } = rowData;
    const { cells, rowSelection } = structure;
    const { onRowClick, onMenuItemClick, onButtonClick } = callbacks;
    const CheckboxCell = allCells[CellType.Checkbox];
    const renderCell = (cell: ICell, index: number) => {
        const { id: cellId, cellFields, alignment, stickyColumn } = cell;

        const cellData = Object.keys(cellFields).reduce(
            (output, destKey) => {
                const sourceKey = cellFields[destKey];
                output[destKey] = data[sourceKey];
                return output;
            },
            {} as Record<string, string>
        );

        const Cell = allCells[cell.type];
        return (
            <Cell
                alignment={alignment}
                key={cellId}
                data={cellData}
                stickyColumn={stickyColumn}
                rowStickyWidths={[]} //TODO: fix
                columnIndex={index}
                onMenuItemClick={onMenuItemClick}
                onButtonClick={onButtonClick}
                rowData={rowData}
                id={cellId}
            />
        );
    };

    const renderCells = () => {
        return cells.map((cell, index) =>
            renderCell(cell, rowSelection ? index + 1 : index)
        );
    };

    const onClick = (event: SyntheticEvent) => {
        const target = event.target as HTMLElement;
        if (
            target instanceof HTMLInputElement &&
            (target.type === 'checkbox' || target.type === 'radio')
        ) {
            return;
        }

        if (onRowClick) {
            onRowClick(rowData);
        }
    };

    return (
        <StyledTableRow
            key={rowIndex}
            isReadOnly={!rowSelection}
            isRowClickable={!!onRowClick || false}
            onClick={onClick}
            isSelected={isSelected}
        >
            {rowSelection && (
                <CheckboxCell
                    onSelectionChange={() =>
                        onSelectionChange && onSelectionChange(data?.id)
                    }
                    alignment={'center'}
                    isItemSelected={isSelected}
                />
            )}
            {renderCells()}
        </StyledTableRow>
    );
};

export default Row;
